// extracted by mini-css-extract-plugin
export default {"root":"_5PAtb","label":"_3bOZ4","value":"_2z2W3"};